
export const HANGMAN_API = 'https://flask-hangman-api.herokuapp.com';
// export const HANGMAN_API = 'http://localhost:5000';



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/